import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(() => ({
	tag: {
		"& svg path": {
			fill: "#FFFFFF"
		}
	}
}));

export default styles;
